import { Card, Grid } from "@mui/material";
import { BarChartOutlined } from "@mui/icons-material";
import { mutate } from "swr";
import { CustomAutocomplete } from "../../../../components/custom/CustomAutocomplete";
import useResponsive from "../../../../components/hooks/useResponsive";
import { sendData } from "../../../../lib/dashboard/actions";
import AddToFavoritesButton from "../../../../components/favorite/AddToFavoritesButton";
import Loading from "../../../../components/loader/Loading";
import { useDomesticMarketProductPriceChartProducer } from "../../../../context/domestic-market/product-price-chart/DomesticMarketProductPriceChartProducerContext";

const ProducerForm = () => {
  const {
    companies,
    groups,
    commodities,
    producerInputValue,
    setProducerInputValue,
    isLoadingChart,
    handleShowChart,
    isFavoritesValidation,
  } = useDomesticMarketProductPriceChartProducer();

  const { isXl, isLg } = useResponsive();

  const { company, group, commodity } = producerInputValue;

  const body = {
    company_id: company?.id,
    group_id: group?.id,
    commodity_id: commodity?.id,
  };

  const handleAddToFavorite = async () => {
    const res = await sendData(body, "/favorite/domestic-price/producer");
    if (res.status === 200) await mutate("/favorite/domestic-price/producer");
  };

  const clearForm = (field) => {
    switch (field) {
      case "company":
        setProducerInputValue((prev) => ({
          ...prev,
          group: null,
          commodity: null,
        }));
        break;
      case "group":
        setProducerInputValue((prev) => ({
          ...prev,
          commodity: null,
        }));
        break;

      default:
        break;
    }
  };

  const isDisabled = [company?.id, group?.id].every(Boolean);

  return (
    <Card>
      <Grid container spacing={1} alignItems={"center"}>
        {isLg && (
          <Grid item xs={12} md={6} lg={isXl ? 0.5 : 1}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={!isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid>
        )}

        <Grid item xs={12} md={6} lg={3.25}>
          <CustomAutocomplete
            options={companies.data}
            value={company}
            onChange={(e, newValue) => {
              setProducerInputValue((prev) => ({ ...prev, company: newValue }));
              clearForm("company", newValue);
            }}
            isLoading={companies.isLoading}
            placeholder="شرکت"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={3.25}>
          <CustomAutocomplete
            options={groups.data}
            value={group}
            onChange={(e, newValue) => {
              setProducerInputValue((prev) => ({ ...prev, group: newValue }));
              clearForm("group", newValue);
            }}
            isLoading={groups.isLoading}
            placeholder="گروه"
          />
        </Grid>
        <Grid item xs={12} md={6} lg={3.25}>
          <CustomAutocomplete
            options={commodities.data}
            value={commodity}
            onChange={(e, newValue) => {
              setProducerInputValue((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid>

        <Grid item xs={10} md={5} lg={isXl ? 1.75 : 1.25}>
          <button
            style={{ height: "43px" }}
            onClick={() => handleShowChart(body)}
            className={`btn ${!isDisabled ? " btn-softblue" : "btn-blue"}`}
            disabled={!isDisabled || isLoadingChart}
          >
            {isLoadingChart ? (
              <Loading color={"#fff"} />
            ) : (
              <>
                {(isXl || !isLg) && "نمایش"}
                <BarChartOutlined />
              </>
            )}
          </button>
        </Grid>

        {!isLg && (
          <Grid item xs={2} md={1}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={!isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default ProducerForm;
